<div class="pane-header">
  <h3 class="title"></h3>
  <div class="actions">
    <span class="close">
      {{{ icon 'close' 'Close' }}}
    </span>
  </div>
</div>
<div class="pane-body">
  <div class="segments">
    <nav role="tablist" class="tab-selectors tab-selectors--primary edit-form-nav">
      <label class="tab-selector tab-selector--first" for="component-preview" role="tab">
        <input class="tab-selector-radio" type="radio" value="component-preview" id="component-preview" name="image-dialog-tab" data-behaviour="tabstate" aria-controls="component-preview-tab">
        <span class="tab-label">Preview</span>
      </label>

      <label class="tab-selector" for="component-uses" role="tab">
        <input class="tab-selector-radio" type="radio" value="component-uses" id="component-uses" name="image-dialog-tab" data-behaviour="tabstate" aria-controls="component-uses-tab">
        <span class="tab-label">Uses</span>
      </label>

      <label class="tab-selector tab-selector--last" for="component-info" role="tab">
        <input class="tab-selector-radio" type="radio" value="component-info" id="component-info" name="image-dialog-tab" data-behaviour="tabstate" aria-controls="component-info-tab">
        <span class="tab-label">Info</span>
      </label>
    </nav>
  </div>

  <div id="component-preview-tab" role="tabpanel">
    <sp-alert type="info" class="centered">
      This is the component as it appears with default content, sizing, and appearance.
    </sp-alert>
    <div class="component-preview-container">
      <iframe class="component-preview" onload="this.style.height = this.contentWindow.document.body.scrollHeight + 'px';"></iframe>
    </div>
  </div>

  <div id="component-uses-tab" role="tabpanel">
  </div>

  <div id="component-info-tab" role="tabpanel">
  </div>
</div>
<div class="pane-footer"></div>
